/* Angular Stuff*/
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/* Our Own Stuff*/
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';
import { DateService } from 'src/app/shared';

@Component({
    selector: 'app-hr-grade',
    templateUrl: './../../../templates/forms/modals/grade-list.component.html',
})
export class GradeListComponent implements OnInit {
    @Input()
    modalShow: boolean = true;

    @Input()
    optionalParam;

    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    dataObj: any;

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "HrGradeGrid"

    gradeList: any[] = [];
    public searchString;
    constructor(private dataService: DataLoadService,
        public langService: LangService,
        public gridService: GridService,
        public dateService: DateService) {
        this.colObj = [
            { headerName: langService.langData.jobTitle, field: 'JOBTITLE', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.grade, field: 'GRADE', sortable: true, resizable: true, hide: false },
            {
                headerName: langService.langData.ruleDate, field: 'RULE_DATE', sortable: true, resizable: true, hide: false, cellRenderer: data => {
                    return this.dateService.getDDMMYYYYSlashFromDate(new Date(data.value))
                }
            },
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);
        this.dataService.load('FG_HR_COMM_JOBTITLE_PAYSCALE', JSON.parse(JSON.stringify(this.optionalParam))).subscribe(results => {
            this.gradeList = results.body;
        });
    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;   // dataObj is unnecessary as selected-data (_item) can be directly passed to next
        this.submit.next(_item);
    }

} 